

export const getDates = function(startDate, endDate){
  
  let dates = [],
      currentDate = startDate,
      addDays = function(days){
        let date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };

  while(currentDate <= endDate){
    dates.push(currentDate);
    currentDate = addDays.call(currentDate, 1);
  }

  return dates;

}
